<script setup lang="ts">
import UISpinnerNew from '@/components/ui/UISpinnerNew/UISpinnerNew.vue';
</script>

<template>
  <div
    class="z-10 flex size-full cursor-wait items-center justify-center bg-white/20 backdrop-blur-[2px]"
  >
    <UISpinnerNew size="md" />
  </div>
</template>
